module.exports = "/_next/static/images/Introduction@2x-273507fddc22df650edfed508cc35f7a.png";